// Include Stylesheet
require("../../css/src/stylesheet.scss");

// Include Offset Base Resources
require("OffsetBaseResources");

// Configure Offset APIs
require("./offset.config.js");

// Custom Site Stuff
require("./theme.js");
require("./site-header.js");
require("./crossfade-carousel.js");
require("./video-hero.js");
require("./nav-submenu.js");
require("./mobile-nav.js");
require("./wine-specs.js");
require("./notes-back.js");
require("./land-map.js");
require("./form-validation-message.js");
require("./new-address-submit-button.js");
require("./consent-modal-layer.js");
require("./modal-scroll-lock.js");

// Google Places Autocomplete
require("./place-autocomplete.js");

// Material Design
//require("./material-design.js");

// Load via script tag:
// require('script-loader!./scroller.js')

// Expose a variable from a library:
// const scroller = require('expose-loader?scroller!./scroller.js')

// Offset Consent
const { ConsentManager, ConsentUI } = require("offset-consent");
window.OffsetConsent = new ConsentUI(new ConsentManager(window.OFFSET.consent));
window.OffsetConsent.mount();
